module.exports = __webpack_public_path__ + "static/media/tia.199f3d2e.png";